//NPM
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { map } from "lodash";

// UTILITY
import errorHandler from "Utils/error-handler";

// HELPERS
import { toaster } from "Helpers/toaster";
import { toNum } from 'Helpers/get-to-num';

//STYLE
import "../parcel-tracking-modals.scss";

// HOOKS
import useSession from "Hooks/session.hook";

//ANT COMPONENTS
import { Col, Row } from "antd";
import { WarningOutlined } from "@ant-design/icons";

// SHARED
import {
  AlertBox,
  Button,
  SelectInput,
  TextInput,
  DataTable,
} from "@life-line-lab/components-react";
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";

const CreateNewBatchModal = ({ selectedOrdersObj, selectedOptions, handoverOptions, filterFlag, onSubmit, handleCancel }) => {
  const { t } = useTranslation();

  const [selectedHandoverPoint, setSelectedHandoverPoint] = useState<any>("")

  const handleSelectChange = (value: string | string[], name: string) => {
    setSelectedHandoverPoint(value);
  }

  const handleSubmit = () => {
    let volume = 0
    selectedOrdersObj.map(order => {
      return (
        volume = volume + toNum(order.volume)
      )
    })
    const payload = {
      batchParcel: {
        noOfParcels: (selectedOrdersObj.length).toString(),
        parcelList: selectedOrdersObj.map(order => {
          return (
            order._id
          )
        }),
        merchantID: selectedOrdersObj.map(order => {
          return (
            order.senderID._id
          )
        }),
        sortingHub: selectedOptions.sortingHub,
        handoverPoint: selectedHandoverPoint,
        totalVolume: volume.toString(),
        status: "OPEN",
      },
      // sortingHubID: selectedOptions.sortingHub,
      filterFlag: filterFlag,
    }
    onSubmit(payload)
  }

  return (
    <div className="parcel-tracking-modal">
      <Row className="">
        <Col span={1} className="mt-6 mr-6">
          <WarningOutlined className="color-danger title" />
        </Col>
        <Col span={20} className="mb-0">
          <ModuleTitleBar titleText={t("title.createNewBatch").toUpperCase()} />
        </Col>
      </Row>
      <div>
        <h3>Are you sure you want to create a new batch with these parcels?</h3>
        {selectedOrdersObj.map(order => {
          return (
            <Row className="mt-10">
              <h4>{order.orderCode}</h4>
            </Row>
          )
        })}
      </div>
      <div>
        <br />
        <h3>Select handover point for this batch:</h3>
        <SelectInput
          showSearch
          isRequired={true}
          onChange={(value: string | string[]) =>
            handleSelectChange(value, 'handoverPoint')}
          options={
            handoverOptions?.map(place => {
              return {
                label: place.locationName || "",
                value: place._id
              }
            })
          }
          filterOption={(inputValue, option) =>
            option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
          }
        />
      </div>
      <div className="mt-30 right">
        <Button
          type={"primary"}
          label={t("action.confirm")}
          onClick={() => {
            handleSubmit();
          }}
        />
        <Button
          className="cancel-btn"
          type={"default"}
          label={t("action.cancel")}
          onClick={handleCancel}
        />
      </div>
    </div>
  );
};

export default CreateNewBatchModal;
